export const UPLOAD_DATA_SERVICES: string =
  'src/pages/upload-info/UPLOAD_DATA_SERVICES';
export const UPLOAD_DATA_SERVICES_SUCCESS: string =
  'src/pages/upload-info/UPLOAD_DATA_SERVICES_SUCCESS';
export const UPLOAD_DATA_SERVICES_FAILED: string =
  'src/pages/upload-info/UPLOAD_DATA_SERVICES_FAILED';
